import React, { Component } from 'react'
import { TryMap } from '../index'


class DeleteRoute extends Component {
    render() {
        const { Waypoints, Routes, GetRoutePoints, RouteDoc, DeleteRoute } = this.props
        // const { waypoints, Routes, GetRoutePoints, unasignedPartners, RouteDoc, ChangeEditedRoutestatus, SetData, SaveUpdatedRoute, AddtoEditedRoute,DeleteEditedPartners } = props
        return (
            <div className='m-5'>
                <div id="create-Route-form" style={{ marginTop: "2vh" }}>
                    <div class="content-wrapper">
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div className='row'>
                                <div class="col-lg-12 mb-4 order-0">
                                    <div class="card h-100">
                                        <div class="d-flex align-items-end row">
                                            <div class="col-sm-12">
                                                <div class="card-body" >
                                                    <div style={{ height: '400px', }}>
                                                        <TryMap
                                                            waypoints={Waypoints}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div class="col-lg-8 mb-4 order-0">
                                    <div class="card h-100">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h5 class="card-title m-0 me-2">Rutas registradas</h5>
                                        </div>
                                        <div class="card-body scrollCardBP" >
                                            <ul class="p-0 m-0">
                                                {Routes && Routes.map((route, index) => {
                                                    return (
                                                        <li class="d-flex mb-4 pb-1" onClick={() => GetRoutePoints(route)} >
                                                            <div class="avatar flex-shrink-0 mr-2 ml-2 mt-2">
                                                                <img style={{ maxHeight: "25px", maxWidth: "25px" }}
                                                                    src={require('../../images/ico/routeMap.png')} alt="User" class="rounded" />
                                                            </div>
                                                            <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                <div class="me-2">
                                                                    <small class="text-muted d-block mb-1">{route.RouteName}</small>
                                                                    <h6 class="mb-0">{route.RouteCode} </h6>
                                                                </div>
                                                                <div class="user-progress d-flex align-items-center gap-1 mr-2">
                                                                    {
                                                                        route.IsActive === 1 ?
                                                                            <i className="fa fa-arrow-up" style={{ color: "#2dbb55" }} ></i>
                                                                            :
                                                                            <i className="fa fa-arrow-down" style={{ color: 'red' }} ></i>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8 col-lg-4 order-3 order-md-2">
                                    <div class="row">

                                        <div class="col-12 mb-4">
                                            <div class="card h-100">
                                                <div class="card-title card-header ">
                                                    <h5 class="text-nowrap mb-2">Datos de la ruta</h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between flex-sm-row flex-column gap-3">
                                                        <div class="flex-sm-column flex-row align-items-start justify-content-between">
                                                            <div>
                                                                <h5 class="mb-1">Código: {RouteDoc ? RouteDoc.Code : ''}</h5>
                                                                <h5 class="mb-1">Nombre: {RouteDoc ? RouteDoc.Name : ''} </h5>
                                                                <h5 class="mb-1">Ruta: {RouteDoc && RouteDoc.IsActive === 1 || RouteDoc.isActive === true ? 'Activa' : 'Desactivada'} </h5>
                                                            </div>
                                                            <div class="mt-sm-auto">
                                                                {/* <small class="text-success text-nowrap fw-semibold"><i class="bx bx-chevron-up"></i> 68.2%</small> */}
                                                                <h4 class="mt-1">Socios: {`${RouteDoc && RouteDoc.RoutesLines.length} en la ruta`} </h4>
                                                            </div>
                                                        </div>
                                                        <div id="profileReportChart"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-4">
                                            <div class="card h-100" onClick={() => DeleteRoute()}>
                                                <div class="card-body">
                                                    <div class="card-title d-flex align-items-start justify-content-between">
                                                        <div class="avatar flex-shrink-0">
                                                            Eliminar
                                                        </div>
                                                    </div>
                                                    {/* <span class="d-block mb-1">Payments</span>
                                                <h3 class="card-title text-nowrap mb-2">$2,456</h3>
                                                <small class="text-danger fw-semibold"><i class="bx bx-down-arrow-alt"></i> -14.82%</small> */}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div class="col-6 mb-4">
                                        <div class="card">
                                            <div class="card-body h-100">
                                                <div class="card-title d-flex align-items-start justify-content-between">
                                                    <div class="avatar flex-shrink-0">
                                                        Desactivar
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content-backdrop fade"></div>
                    </div>

                </div>



            </div>
        )
    }
}

export default DeleteRoute